// src/pages/nascar/CupGfs.jsx
import React from "react";
import NascarGfsPage from "../../components/NascarGfsPage";

export default function CupGfs() {
  return (
    <NascarGfsPage
      title="Cup GFS Model"
      seriesKey="cup"
    />
  );
}
